import { isServerSideRendering } from 'helpers/env';
import Cookies from 'js-cookie';
import itly, { ContextProperties } from 'itly';
import { setFbClickId } from './tracking';

declare global {
  interface Window {
    itly: typeof itly;
    yotpo: any;
    dataLayer: Array<any>;
  }
}

type InitItlyParams = {
  enabled: boolean;
  environment: 'production' | 'development';
  context: ContextProperties;
  destinations?: any;
};

export function analyticsInit({
  enabled = false,
  environment = 'development',
  context,
  destinations
}: InitItlyParams): void {
  itly.load({ environment, disabled: !enabled, context, destinations });
  if (window) {
    window.itly = window.itly || itly;
  }
}

const FBCLID = 'fbclid';
const FBC_COOKIE_NAME = '_fbc';
const FBC_CLICK_ID_INDEX = 3;

export const captureFbclid = (): void => {
  const fbclid = getFbclidFromQueryParams() ?? getFbclidFromCookies();
  if (fbclid) {
    setFbClickId(fbclid);
  }
};

const getFbclidFromQueryParams = () => {
  if (isServerSideRendering()) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  return params.get(FBCLID);
};

const getFbclidFromCookies = () => {
  if (isServerSideRendering()) {
    return null;
  }
  const fbc = Cookies.get(FBC_COOKIE_NAME);
  return fbc?.split('.')[FBC_CLICK_ID_INDEX];
};
